





























helpers = require('../../helpers.coffee')

view_model =
  components: { templateForm: require('./form') }
  data: ->
    template: {}
    update_flow_templates: true
    options:
      responsible: 'disabled'

  computed:
    actions_count_text: ->
      text = if @template.actions_count <= 1 then 'fluxo' else 'fluxos'
      @template.actions_count + " " + text
    optionsLabel: -> 
      this.$t('template.label.optionsLabel', { actionsCountText: this.actions_count_text })

  methods:
    loadTemplate: ->
      Loader.on()
      @templates_resource.get(@loadTemplateSuccess, @unknownError, id: @$route.params.id)

    loadTemplateSuccess: (data) ->
      Loader.off()
      @template = data.template
      @template.user_id = data.template.user.id
      IntercomCtrl.trackEvent(this.$t('template.label.templateViewer'))

    save: ->
      Loader.on()
      if @update_flow_templates
        @templates_resource.update(@saveSuccess, @unknownError, @template)
      else
        @templates_resource.create(@saveSuccess, @unknownError, @template)

    saveSuccess: (response) ->
      Loader.off()
      @$router.push('/templates')
      alertify.success this.$t('template.label.saveSuccess')
      @trackIntercomEvent(response) if response

    saveConfirmation: (data) ->
      Loader.off()
      if !data.attr.metadata.submittable
        @saveSuccess()
      else if @template.actions_count > 0
        EventsBus.$emit 'confirm-modal-show', id: 'confirm-edit-template'
      else
        @save()

    trackIntercomEvent: (response) ->
      template = if response.data then response.data.template else response.template
      metadata = [
        { value: "#{location.href}/#{template.id}/editar", key: this.$t('template.label.templateURL') }
        { attribute: 'body', key: this.$t('template.label.imagesContentLength'), function: 'htmlImgTagQuantity' },
        { attribute: 'body', key: this.$t('template.label.hiperlinksContentLength'), function: 'htmlATagQuantity' },
        { attribute: 'signature', key: this.$t('template.label.imagesSignatureLength'), function: 'htmlImgTagQuantity' },
        { attribute: 'signature', key: this.$t('template.label.hiperlinksSignatureLength'), function: 'htmlATagQuantity' }
      ]
      IntercomCtrl.trackEventMetadata(this.$t('template.label.templateEditing'), metadata, null, template)

  created: ->
    @templates_resource = new TemplatesResource(Session.current_company.id)
    @loadTemplate()

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/templates/edit.vue